import { combineReducers } from 'redux';
import { IPendingEventNote } from '../../data/entities/event/event-note';
import { Actions, ActionTypes } from './actions';

export const pendingEventNoteData = (state = [], action: Actions = {} as any): IPendingEventNote[] => {
	switch (action.type) {
		case ActionTypes.EVENT_NOTE_CREATE_QUEUE:
			return [...state, action.payload];
		case ActionTypes.EVENT_NOTE_CREATE_QUEUE_CLEAR:
			return [];
		default:
			return state;
	}
};

export interface IPendingEventNoteState {
	pendingEventNoteData: ReturnType<typeof pendingEventNoteData>;
}

const pendingEventNotes = combineReducers<IPendingEventNoteState>({
	pendingEventNoteData
});

export default pendingEventNotes;
